import * as Yup from "yup";

export const ValueTypeOptions = [{
  name: "valuetype",
  value: "UOM",
  options: [
    { value: "integer", label: "Integer" },
    { value: "string", label: "Text" },
    { value: "bool", label: "Boolean" },
    { value: "float64", label: "Decimal" },
  ],
}]

export const RoundingRuleOptions = [{
  name: "roundingRule",
  value: "UOM",
  options: [
    { value: "Up", label: "Up" },
    { value: "Down", label: "Down" },
    { value: "Half-Up", label: "Half-Up" },
    { value: "Half-Down", label: "Half-Down" },
  ],
}]

export const initialFormValues = {
  name: "",
  valuetype: "",
  roundingRule: "",
};

export const validationSchema = Yup.object().shape({
  name: Yup.string().required("Enter the uom name"),
  valuetype: Yup.mixed().required("Enter the value type"),
  // stepQuantity:Yup.string().required("Enter the Step Quantity")
});
